// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Decimal } from 'decimal.js';

/**
 * Isolated decimal constructor for all currency math. A clone is immune to
 * global Decimal.set() reconfiguration elsewhere in the bundle, and the
 * pinned exponent range keeps toString in plain (never exponential) notation.
 */
export const CurrencyDecimal = Decimal.clone({
  precision: 20,
  rounding: Decimal.ROUND_HALF_EVEN,
  toExpNeg: -9e15,
  toExpPos: 9e15,
});
